import React from 'react';
import PropTypes from 'prop-types';
import './BodyStyle.css'; 

const BodySmallMedium = ({ text, color }) => {
  return (
    <p className="body-small-medium" style={{ color: color }}>
      {text}
    </p>
  );
};

BodySmallMedium.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default BodySmallMedium;
